import React from 'react';
import { Loader2 } from 'lucide-react';

export const LoadingOverlay = ({ tr, hasUploads }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/60 backdrop-blur-sm"
    role="dialog"
    aria-modal="true"
    data-testid="wizard-loading-overlay"
  >
    <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md mx-4 text-center">
      <Loader2 className="w-10 h-10 mx-auto mb-4 text-blue-900 animate-spin" />
      <p
        className="text-gray-900 font-semibold mb-1"
        style={{ fontFamily: 'Garamond, serif', fontSize: '1.25rem' }}
      >
        {hasUploads ? tr('wizard.overlay.titleUpload') : tr('wizard.overlay.titleSubmit')}
      </p>
      <p className="text-sm text-gray-600">{tr('wizard.overlay.subtitle')}</p>
    </div>
  </div>
);
